import { verifyFieldNames } from '@/pages/timeline/sections/timeline/timelineSections/verify/constants/index'

import BasicDetails from "@/pages/profile/sections/basicDetails/main"
import LegalInfo from "@/pages/profile/sections/legalInfo/main"
import AddressDetails from "@/pages/profile/sections/addressDetails/main"
import IdVerification from "@/pages/profile/sections/idVerification/main"
import BssDetails from "@/pages/profile/sections/bssDetails/main"


import './style.css'

export default function ProfileMainView(props: any) {
    const componentMap: any = {
        [verifyFieldNames.basicDetailsStatus]: <BasicDetails />,
        [verifyFieldNames.legalInfoStatus]: <LegalInfo />,
        [verifyFieldNames.addressDetailsStatus]: <AddressDetails />,
        [verifyFieldNames.idVerificationStatus]: <IdVerification />,
        [verifyFieldNames.bssDetailsStatus]: <BssDetails />,
    };

    const ComponentToRender = componentMap[props.sourceComingFrom];
    return (
        <div className="profileMainView">
            {props.isLoading ? (
            // {true ? ( // testing

                <div className="basicDetailsView basicDetailsView_loaderMaincon rounded-[10px] p-4 shadow-lg w-[100%] animate-pulse">
                    <div className="mb4">
                        <div className="h-6 basicDetailsView_loaderMaincon_1 rounded w-3/4 mb-4" />
                        <div className="space-y-2 basicDetailsView_loaderMaincon_2 p-4 rounded">
                            <div className="h-4 basicDetailsView_loaderMaincon_3 rounded w-5/6" />
                            <div className="h-4 basicDetailsView_loaderMaincon_4 rounded w-4/6" />
                            <div className="h-4 basicDetailsView_loaderMaincon_5 rounded w-3/6" />
                        </div>
                    </div>

                    <div className="mb-4">
                        <div className="h-5 mt-[6px] basicDetailsView_loaderMaincon_6 rounded w-2/5 mb-2" />
                        <div className="h-10 basicDetailsView_loaderMaincon_7 rounded" />
                    </div>

                    <div className="flex justify-end">
                        <div className="h-10 w-10 basicDetailsView_loaderMaincon_8 rounded-full" />
                    </div>
                </div>
            ) : (
                // <div className='bg-white rounded-[10px] con1'>
                <div>
                    {ComponentToRender || null}
                </div>
            )}
        </div>
    );
}
